import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import GlgInlineLoadingSpinner from '../../../../shared/components/glg_loading_spinner_inline'
import { useGetNgfCoursesForClubQuery } from '../../../api/courses'

export const Step1Ngf = ({ selectedClubId, onClubSelect, selectedCourseId, onCourseSelect }) => {
  const ngfClubs = useSelector((state) => state?.misc?.data?.ngfClubs || [])
  const ngfDefaultClubId = useSelector((state) => state?.misc?.data?.ngfDefaultClubId)

  const effectiveClubId = selectedClubId || ngfDefaultClubId

  const { data: courses, isLoading: coursesLoading } = useGetNgfCoursesForClubQuery(
    { selected_club_id: effectiveClubId },
    { skip: !effectiveClubId }
  )

  return (
    <div>
      <div className="courses-modal-dropdown-label add-margin-top-10">
        {window.I18n.t('courses.ngf.popup.select_club')}
      </div>
      <select
        className="form-control add-margin-bottom-10"
        value={effectiveClubId || ''}
        onChange={(e) => onClubSelect(e.target.value)}
      >
        <option value="" disabled>{window.I18n.t('courses.ngf.popup.select_a_club')}</option>
        {ngfClubs.map((club) => (
          <option key={club.value} value={club.value}>{club.label}</option>
        ))}
      </select>

      {effectiveClubId && (
        <>
          <div className="courses-modal-dropdown-label add-margin-top-10">
            {window.I18n.t('courses.ngf.popup.select_course')}
          </div>
          {coursesLoading ? (
            <GlgInlineLoadingSpinner show={true} />
          ) : (
            <select
              className="form-control"
              value={selectedCourseId || ''}
              onChange={(e) => {
                const selected = courses?.find((c) => String(c.value) === e.target.value)
                onCourseSelect(e.target.value, selected?.label || '')
              }}
            >
              <option value="" disabled>{window.I18n.t('courses.ngf.popup.select_a_course')}</option>
              {(courses || []).map((course) => (
                <option key={course.value} value={course.value}>{course.label}</option>
              ))}
            </select>
          )}
        </>
      )}
    </div>
  )
}

Step1Ngf.propTypes = {
  selectedClubId: PropTypes.string,
  onClubSelect: PropTypes.func.isRequired,
  selectedCourseId: PropTypes.string,
  onCourseSelect: PropTypes.func.isRequired,
}
